import styled, { css } from 'styled-components';
import React from 'react';

const ButtonWrap = styled.button<ButtonStyleProps>`
  text-align: center;
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '51px')};
  border: ${(props) => (props.border ? props.border : 'none')};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : 'none')};
  background-color: ${(props) =>
    props.disabled ? '#eee' : props.backgroundColor ? props.backgroundColor : 'transparent'};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props) => (props.fontColor ? props.fontColor : '#fff')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '13.5px')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '400')};
  letter-spacing: ${(props) => (props.letterSpacing ? props.letterSpacing : '-1px')};
  text-decoration: ${(props) => (props.textDecoration ? props.textDecoration : 'none')};

  ${(props) =>
    props.backgroundImage &&
    css`
      background-image: url('${props.backgroundImage}');
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 40px;
    `};

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}
`;

export interface ButtonStyleProps {
  borderRadius?: string;
  fontSize?: string;
  letterSpacing?: string;
  backgroundColor?: string;
  fontColor?: string;
  fontWeight?: number;
  backgroundImage?: string;
  active?: boolean;
  border?: string;
  height?: string;
  width?: string;
  textDecoration?: string;
  disabled?: boolean;
  display?: string;
}

interface ButtonProps {
  onClick: (e: React.MouseEvent) => void;
  text?: string;
  imgSrc?: string;
  styles?: ButtonStyleProps;
  disabled?: boolean;
}

const Button = (props: ButtonProps) => {
  const { onClick, disabled, styles, text } = props;
  const textButton = !!text && <span>{text}</span>;

  return (
    <ButtonWrap onClick={onClick} {...styles} disabled={disabled}>
      {textButton}
    </ButtonWrap>
  );
};

export default Button;
